/* VIP Sale 2026 – vip-savecart.js (Eigentümer: T7, 19.10.2026)
   Warenkorb speichern & per E-Mail an sich selbst senden.

   Ablauf:
     1. Kachel „Warenkorb speichern & per E-Mail senden“ (snippets/vip-cart-savecart.liquid, unter dem Kasse-Button
        in Drawer + Warenkorbseite) -> Modal (Markup aus <template data-vip-savecart-template>, wird EINMAL nach
        <body> geklont, weil .drawer__inner ein transform hat und position:fixed dort nicht greift).
     2. Absenden: Permalink https://www.my-harry.de/cart/VARIANTE:MENGE,… (ohne Gratis-Teppich-Zeilen _vip_gift,
        ?storefront=true -> Warenkorbseite statt Checkout, Cart-Attribute wie „Wunschtermin“ werden mitgegeben)
        + Klaviyo-Event „Warenkorb gespeichert“ mit Positionen, Zwischensumme, Permalink, VIP-Phase.
     3. Versand des Events:
          a) Klaviyo Client-API (POST a.klaviyo.com/client/events, company_id = oeffentlicher Site-Key) –
             unabhaengig davon, ob klaviyo.js geladen/vom Consent-Tool blockiert ist (gleiche Technik wie
             assets/mh-konf-suite.js und sections/mh-vip-popup.liquid). unique_id verhindert Doppel-Events.
             Zusaetzlich identify() ueber das Onsite-Objekt (window.klaviyo), damit der Browser dem Profil zugeordnet
             wird – KEIN zweites track(), sonst wuerde der Flow zweimal feuern.
          b) Faellt a) aus: Onsite-API klaviyo.push(['identify',…]) + klaviyo.push(['track',…]) (falls geladen).
          c) Faellt auch b) aus: mailto:-Link mit Betreff „Mein my-Harry Warenkorb“ (Permalink + Positionen als Text).
     4. Erfolgsmeldung „Wir haben dir deinen Warenkorb geschickt“ + Link zum Kopieren.

   Idempotent: der Warenkorb-DOM wird vom Theme bei jeder Aenderung neu gerendert -> Trigger per delegiertem Klick
   auf document, Modal lebt im <body>, Zusammenfassung aktualisiert sich ueber document 'vip:cart'.
   Test: window.VIP_SAVECART_TEST = function (payload) {…} ersetzt den Versand an Klaviyo.
*/
(function () {
  'use strict';
  if (window.VIP_SAVECART && window.VIP_SAVECART.__init) return;

  var METRIC = 'Warenkorb gespeichert';
  var LIST_ID = 'Tawx2a';                                  // Klaviyo-Liste (Markus, 19.10.): alle, die den Warenkorb speichern
  var LIST_SOURCE = 'VIP Sale – Warenkorb gespeichert';    // custom_source im Subscribe
  var COMPANY_FALLBACK = 'Lzhzq2';
  var REVISION = '2025-07-15';
  var SS_EMAIL = 'vip_savecart_email';
  var MODAL_ID = 'vip-savecart-modal';
  var CANON = 'https://www.my-harry.de';

  var state = { modal: null, lastPayload: null, busy: false, keyHandler: null };

  /* ---------- Helfer ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ss(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v); } catch (e) {} return null; }
  function log() { try { var a = Array.prototype.slice.call(arguments); a.unshift('[VIP savecart]'); console.info.apply(console, a); } catch (e) {} }
  function warn() { try { var a = Array.prototype.slice.call(arguments); a.unshift('[VIP savecart]'); console.warn.apply(console, a); } catch (e) {} }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); }
  function vip() { return window.VIP || null; }
  function cart() { var v = vip(); return (v && v.cart) || null; }
  function isGift(item) { var v = vip(); if (v && typeof v.isGiftLine === 'function') return v.isGiftLine(item); return !!(item && item.properties && item.properties._vip_gift); }
  function fmt(cents) { var v = vip(); if (v && v.formatEUR) return v.formatEUR(cents); return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function eur(cents) { return Math.round(Number(cents) || 0) / 100; }
  function origin() {
    try { if (/(^|\.)my-harry\.(de|at)$/i.test(window.location.hostname)) return window.location.origin; } catch (e) {}
    return CANON;
  }
  function companyId() {
    try {
      var cfg = window.VIP_CONFIG && window.VIP_CONFIG.klaviyo && window.VIP_CONFIG.klaviyo.company_id;
      if (cfg) return String(cfg);
      var s = document.querySelector('script[src*="klaviyo.js"][src*="company_id="]');
      if (s) { var m = /company_id=([A-Za-z0-9]+)/.exec(s.getAttribute('src')); if (m) return m[1]; }
      var el = document.querySelector('[data-vip-savecart-open][data-company]');
      if (el && el.getAttribute('data-company')) return el.getAttribute('data-company');
    } catch (e) {}
    return COMPANY_FALLBACK;
  }
  function imageUrl(item) {
    var u = item && item.featured_image && item.featured_image.url || item && item.image || '';
    if (!u) return null;
    try { return u.indexOf('?') > -1 ? u + '&width=360' : u + '?width=360'; } catch (e) { return u; }
  }

  /* ---------- Warenkorb -> Payload ---------- */
  function lines() {
    var c = cart();
    if (!c || !c.items) return [];
    return c.items.filter(function (it) { return it && !isGift(it) && it.quantity > 0; });
  }
  function publicAttributes(c) {
    var out = {}, attrs = (c && c.attributes) || {};
    try {
      Object.keys(attrs).forEach(function (k) {
        if (!k || k.charAt(0) === '_' || attrs[k] === null || attrs[k] === '' || attrs[k] === undefined) return;
        out[k] = attrs[k];
      });
    } catch (e) {}
    return out;
  }
  function buildPermalink(c) {
    var agg = {}, order = [];
    lines().forEach(function (it) {
      var id = it.variant_id || it.id;
      if (!id) return;
      if (!agg[id]) { agg[id] = 0; order.push(id); }
      agg[id] += it.quantity;
    });
    if (!order.length) return null;
    var path = order.map(function (id) { return id + ':' + agg[id]; }).join(',');
    var qs = ['storefront=true'];
    try {
      var attrs = publicAttributes(c);
      Object.keys(attrs).forEach(function (k) {
        qs.push('attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(String(attrs[k])));
      });
    } catch (e) {}
    return origin() + '/cart/' + path + '?' + qs.join('&');
  }
  function buildPayload(email, source) {
    var v = vip(), c = cart();
    var items = lines(), o = origin();
    var subtotal = 0, count = 0;
    var mapped = items.map(function (it) {
      var lp = typeof it.final_line_price === 'number' ? it.final_line_price : it.line_price;
      var p = typeof it.final_price === 'number' ? it.final_price : it.price;
      subtotal += lp || 0; count += it.quantity || 0;
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : null;
      return {
        title: it.product_title || it.title,
        variant_title: vt,
        full_title: it.title,
        quantity: it.quantity,
        price: eur(p),
        price_formatted: fmt(p),
        line_price: eur(lp),
        line_price_formatted: fmt(lp),
        original_line_price: eur(it.original_line_price),
        original_line_price_formatted: fmt(it.original_line_price),
        image: imageUrl(it),
        url: it.url ? o + it.url : null,
        sku: it.sku || null,
        vendor: it.vendor || null,
        variant_id: it.variant_id || null,
        product_id: it.product_id || null
      };
    });
    var basis = v && v.cartBasisCents ? v.cartBasisCents(c) : subtotal;
    var phase = v && v.phase ? v.phase() : null;
    var tier = v && v.tierFor ? v.tierFor(basis) : null;
    var permalink = buildPermalink(c);
    var now = new Date();
    return {
      email: String(email).trim(),
      items: mapped,
      item_count: count,
      subtotal: eur(subtotal),
      subtotal_formatted: fmt(subtotal),
      cart_basis: eur(basis),
      cart_basis_formatted: fmt(basis),
      cart_total: eur(c ? c.total_price : subtotal),
      cart_total_formatted: fmt(c ? c.total_price : subtotal),
      currency: (c && c.currency) || 'EUR',
      permalink: permalink,
      cart_url: o + '/cart',
      shop_url: o,
      vip_phase: phase ? phase.key : null,
      vip_phase_label: phase ? phase.label : null,
      vip_phase_active: !!(phase && phase.active),
      vip_tier_pct: tier ? tier.pct : null,
      vip_tier_min: tier ? tier.min : null,
      vip_tiers_url: (window.VIP_CONFIG && window.VIP_CONFIG.tiers_url) || 'https://vip-sale.my-harry.de',
      attributes: publicAttributes(c),
      source: source || 'cart',
      saved_at: now.toISOString(),
      saved_at_local: now.toLocaleString('de-AT', { timeZone: 'Europe/Vienna' }),
      value: eur(subtotal)
    };
  }

  /* ---------- Klaviyo ---------- */
  function sendClientApi(payload) {
    if (typeof window.VIP_SAVECART_TEST === 'function') { try { window.VIP_SAVECART_TEST(payload, 'event'); } catch (e) {} return Promise.resolve('test'); }
    if (!window.fetch) return Promise.reject(new Error('no fetch'));
    var props = {};
    for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k) && k !== 'email' && k !== 'value') props[k] = payload[k];
    var profile = { email: payload.email };
    if (payload.first_name) profile.first_name = payload.first_name;
    profile.properties = { vip_cart_url: payload.permalink, vip_cart_saved_at: payload.saved_at, vip_cart_value: payload.value, vip_cart_item_count: payload.item_count, vip_cart_phase: payload.vip_phase };
    var body = { data: { type: 'event', attributes: {
      properties: props,
      value: payload.value,
      value_currency: payload.currency || 'EUR',
      time: payload.saved_at,
      unique_id: 'savecart-' + payload.saved_at.replace(/\D/g, '') + '-' + Math.random().toString(36).slice(2, 8),
      metric: { data: { type: 'metric', attributes: { name: METRIC } } },
      profile: { data: { type: 'profile', attributes: profile } }
    } } };
    return window.fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(companyId()), {
      method: 'POST', keepalive: true, mode: 'cors',
      headers: { 'content-type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo events ' + r.status);
      return 'client-api';
    });
  }
  /* Listen-Eintrag NUR bei payload.vip_list_optin === true (freiwillige, nicht vorab angehakte Checkbox im Modal).
     Fehler werden nur geloggt – die Hauptaktion (Event/E-Mail) bleibt davon unberuehrt. */
  function subscribeList(payload) {
    if (!payload || payload.vip_list_optin !== true) { state.lastSubscribe = false; return Promise.resolve(false); }
    state.lastSubscribe = true;
    if (!LIST_ID || !window.fetch) return Promise.resolve(false);
    if (typeof window.VIP_SAVECART_TEST === 'function') { try { window.VIP_SAVECART_TEST(payload, 'subscribe'); } catch (e) {} return Promise.resolve('test'); }
    var prof = { email: payload.email };
    if (payload.first_name) prof.first_name = payload.first_name;
    var body = { data: { type: 'subscription', attributes: {
      custom_source: LIST_SOURCE,
      profile: { data: { type: 'profile', attributes: prof } }
    }, relationships: { list: { data: { type: 'list', id: LIST_ID } } } } };
    return window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId()), {
      method: 'POST', keepalive: true, mode: 'cors',
      headers: { 'content-type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo subscriptions ' + r.status);
      log('Liste ' + LIST_ID + ' – Eintrag angenommen (' + r.status + ')');
      return r.status;
    }).catch(function (err) { warn('Listen-Eintrag fehlgeschlagen (ignoriert)', err); return false; });
  }
  function onsite() {
    var k = window.klaviyo;
    if (k && (typeof k.push === 'function' || typeof k.track === 'function')) return k;
    if (window._learnq && typeof window._learnq.push === 'function') return window._learnq;
    return null;
  }
  function onsiteIdentify(payload) {
    try {
      var k = onsite(); if (!k) return false;
      var p = { $email: payload.email }; if (payload.first_name) p.$first_name = payload.first_name;
      if (typeof k.identify === 'function') k.identify(p); else k.push(['identify', p]);
      return true;
    } catch (e) { return false; }
  }
  function sendOnsite(payload) {
    var k = onsite();
    if (!k) return Promise.reject(new Error('klaviyo onsite not available'));
    try {
      onsiteIdentify(payload);
      var props = {}; for (var key in payload) if (key !== 'email') props[key] = payload[key];
      if (typeof k.track === 'function') k.track(METRIC, props); else k.push(['track', METRIC, props]);
      return Promise.resolve('onsite');
    } catch (e) { return Promise.reject(e); }
  }
  function mailtoHref(payload) {
    var subject = 'Mein my-Harry Warenkorb';
    var body = 'Hallo,\n\nhier ist dein gespeicherter my-Harry Warenkorb (' + payload.item_count + ' Artikel, Zwischensumme ' + payload.subtotal_formatted + '):\n\n';
    payload.items.forEach(function (it) {
      body += '- ' + it.quantity + ' x ' + it.title + (it.variant_title ? ' (' + it.variant_title + ')' : '') + ' – ' + it.line_price_formatted + '\n';
    });
    body += '\nWarenkorb wiederherstellen:\n' + (payload.permalink || payload.cart_url) + '\n\n';
    body += 'Dein VIP-Rabatt wird automatisch an der Kasse abgezogen – je früher du bestellst, desto höher die Stufe.';
    return 'mailto:' + encodeURIComponent(payload.email) + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  /* ---------- Modal ---------- */
  function ensureModal() {
    if (state.modal && document.body.contains(state.modal)) return state.modal;
    var existing = document.getElementById(MODAL_ID);
    if (existing) { state.modal = existing; bindModal(existing); return existing; }
    var tpl = $('template[data-vip-savecart-template]');
    if (!tpl) return null;
    var frag = tpl.content ? tpl.content.cloneNode(true) : null;
    var node = frag ? frag.querySelector('#' + MODAL_ID) : null;
    if (!node) {
      var tmp = document.createElement('div'); tmp.innerHTML = tpl.innerHTML; node = tmp.querySelector('#' + MODAL_ID);
    }
    if (!node) return null;
    document.body.appendChild(node);
    state.modal = node;
    bindModal(node);
    return node;
  }
  function bindModal(m) {
    if (m.__vipBound) return; m.__vipBound = true;
    $all('[data-vip-savecart-close]', m).forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
    var form = $('[data-vip-savecart-form]', m);
    if (form) form.addEventListener('submit', onSubmit);
    var email = $('#vip-savecart-email', m);
    if (email) email.addEventListener('input', function () { setMsg(''); });
    var consent = $('[data-vip-savecart-consent]', m);
    if (consent) consent.addEventListener('change', function () { setMsg(''); });
    m.addEventListener('click', function (e) {
      var copy = e.target.closest && e.target.closest('[data-vip-savecart-copy]');
      if (copy) { e.preventDefault(); copyLink(copy); }
    });
  }
  function setMsg(html, type) {
    var m = state.modal; if (!m) return;
    var box = $('[data-vip-savecart-msg]', m); if (!box) return;
    box.innerHTML = html || '';
    box.className = 'vip-savecart__msg' + (html ? ' is-' + (type || 'error') : '');
  }
  function setBusy(b) {
    state.busy = b;
    var m = state.modal; if (!m) return;
    var btn = $('[data-vip-savecart-submit]', m), lbl = $('[data-vip-savecart-submit-label]', m);
    if (btn) { btn.disabled = !!b; btn.setAttribute('aria-busy', b ? 'true' : 'false'); }
    if (lbl) lbl.textContent = b ? 'Wird gesendet …' : 'Warenkorb per E-Mail senden';
  }
  function renderSummary() {
    var m = state.modal; if (!m) return;
    var items = lines(), count = 0, sum = 0;
    items.forEach(function (it) { count += it.quantity || 0; sum += (typeof it.final_line_price === 'number' ? it.final_line_price : it.line_price) || 0; });
    var cnt = $('[data-vip-savecart-count]', m), tot = $('[data-vip-savecart-total]', m);
    if (cnt) cnt.textContent = count === 1 ? '1 Artikel im Warenkorb' : count + ' Artikel im Warenkorb';
    if (tot) tot.textContent = fmt(sum);
    var sub = $('[data-vip-savecart-submit]', m);
    if (sub && !state.busy) sub.disabled = count === 0;
  }
  function showDone(payload, how) {
    var m = state.modal; if (!m) return;
    var form = $('[data-vip-savecart-form]', m), done = $('[data-vip-savecart-done]', m);
    var txt = $('[data-vip-savecart-done-text]', m);
    if (txt) {
      var extra = how === 'mailto'
        ? 'Dein E-Mail-Programm hat sich geöffnet – schick dir die Nachricht einfach selbst zu.'
        : 'Schau in dein Postfach (' + esc(payload.email) + ') – zur Sicherheit auch im Spam-Ordner.';
      txt.innerHTML = extra +
        (payload.permalink ? '<span class="vip-savecart__linkrow"><button type="button" class="vip-link" data-vip-savecart-copy data-link="' + esc(payload.permalink) + '">Oder Link jetzt kopieren</button></span>' : '');
    }
    if (form) form.hidden = true;
    if (done) { done.hidden = false; done.classList.add('is-visible'); }
    m.classList.add('is-done');
  }
  function resetModal() {
    var m = state.modal; if (!m) return;
    var form = $('[data-vip-savecart-form]', m), done = $('[data-vip-savecart-done]', m);
    if (form) form.hidden = false;
    if (done) { done.hidden = true; done.classList.remove('is-visible'); }
    m.classList.remove('is-done');
    setMsg(''); setBusy(false);
  }
  function copyLink(btn) {
    var link = btn.getAttribute('data-link') || '';
    var ok = function () { btn.textContent = 'Link kopiert ✓'; setTimeout(function () { btn.textContent = 'Oder Link jetzt kopieren'; }, 2500); };
    var fail = function () { try { window.prompt('Link zum Warenkorb:', link); } catch (e) {} };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(ok, fail);
      else fail();
    } catch (e) { fail(); }
  }
  function open(trigger) {
    var m = ensureModal();
    if (!m) { warn('Kein Modal-Template gefunden'); return; }
    resetModal();
    renderSummary();
    var email = $('#vip-savecart-email', m);
    var pre = (trigger && trigger.getAttribute('data-email')) || ss(SS_EMAIL) || '';
    if (email && !email.value) email.value = pre;
    m.__vipFirstName = (trigger && trigger.getAttribute('data-first-name')) || '';
    m.__vipSource = (trigger && trigger.getAttribute('data-source')) || 'cart';
    m.__vipReturnFocus = trigger || null;
    m.hidden = false;
    document.documentElement.classList.add('vip-savecart-open');
    state.keyHandler = function (e) {
      if (e.key === 'Escape' || e.code === 'Escape') { e.stopImmediatePropagation(); e.preventDefault(); if (e.type === 'keyup') close(); }
    };
    // capture-phase, damit der Theme-Drawer (keyup Escape auf document) nicht gleichzeitig zugeht
    document.addEventListener('keydown', state.keyHandler, true);
    document.addEventListener('keyup', state.keyHandler, true);
    setTimeout(function () { try { (email && !email.value ? email : (email || m)).focus(); } catch (e) {} }, 30);
  }
  function close() {
    var m = state.modal; if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.classList.remove('vip-savecart-open');
    if (state.keyHandler) {
      document.removeEventListener('keydown', state.keyHandler, true);
      document.removeEventListener('keyup', state.keyHandler, true);
      state.keyHandler = null;
    }
    try { if (m.__vipReturnFocus && document.body.contains(m.__vipReturnFocus)) m.__vipReturnFocus.focus(); } catch (e) {}
  }

  /* ---------- Absenden ---------- */
  function onSubmit(e) {
    e.preventDefault();
    if (state.busy) return;
    var m = state.modal; if (!m) return;
    var emailEl = $('#vip-savecart-email', m), consent = $('[data-vip-savecart-consent]', m);
    var email = emailEl ? emailEl.value.trim() : '';
    if (!validEmail(email)) { setMsg('Bitte gib eine gültige E-Mail-Adresse ein.'); if (emailEl) emailEl.focus(); return; }
    if (!lines().length) { setMsg('Dein Warenkorb ist leer – leg zuerst etwas hinein.'); return; }

    var payload = buildPayload(email, m.__vipSource);
    if (m.__vipFirstName) payload.first_name = m.__vipFirstName;
    payload.vip_list_optin = !!(consent && consent.checked);
    state.lastPayload = payload;
    ss(SS_EMAIL, email);
    setMsg(''); setBusy(true);

    sendClientApi(payload).then(function (how) {
      onsiteIdentify(payload); // Browser dem Profil zuordnen (kein zweites track)
      return how;
    }).catch(function (err) {
      warn('Client-API fehlgeschlagen, versuche Onsite-API', err);
      return sendOnsite(payload);
    }).catch(function (err) {
      warn('Klaviyo nicht verfügbar, Fallback mailto', err);
      try { window.location.href = mailtoHref(payload); } catch (e) {}
      return 'mailto';
    }).then(function (how) {
      setBusy(false);
      log('Event „' + METRIC + '“ via ' + how, payload);
      if (how !== 'mailto') subscribeList(payload); // nicht awaiten: blockiert nie den Erfolg
      try { document.dispatchEvent(new CustomEvent('vip:savecart', { detail: { payload: payload, via: how } })); } catch (e) {}
      showDone(payload, how);
    });
  }

  /* ---------- Trigger (delegiert, ueberlebt Re-Render) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-vip-savecart-open]') : null;
    if (!t) return;
    e.preventDefault();
    open(t);
  });

  /* ---------- Re-Init bei Warenkorb-Aenderung ---------- */
  document.addEventListener('vip:cart', function () {
    if (!state.modal || state.modal.hidden) return;
    renderSummary();
    if (!lines().length && !state.modal.classList.contains('is-done')) close();
  });

  window.VIP_SAVECART = {
    __init: true,
    open: function () { open($('[data-vip-savecart-open]')); },
    close: close,
    buildPayload: buildPayload,
    buildPermalink: function () { return buildPermalink(cart()); },
    metric: METRIC,
    lastPayload: function () { return state.lastPayload; },
    lastSubscribe: function () { return state.lastSubscribe; }
  };
})();
